import axios from 'axios';
import { ec as EC } from 'elliptic';
import CryptoJS from 'crypto-js';
import {
  TOKENS,
  GOOGLE_APIKEY,
} from '../appconstants';
import { getDeviceFingerprint } from '../services/deviceFingerprint';

const ec = new EC('p256');

export const ROOT_URL = process.env.REACT_APP_API_ENDPOINT;
export const ROOT_URL_PAY = process.env.REACT_APP_PAY_API_ENDPOINT;
export const ROOT_LOGIN_URL = process.env.REACT_APP_LOGIN_API_ENDPOINT;
export const ROOT_HEALTH_URL = 'https://staging-backend.swirepay.com';
export const ROOT_URL2 = process.env.REACT_APP_API2_ENDPOINT;
export const ROOT_URL3 = process.env.REACT_APP_API3_ENDPOINT;

export const HEALTHAPI = axios.create({
  baseURL: ROOT_HEALTH_URL
});

export const PAYAPI = axios.create({
  baseURL: ROOT_URL_PAY
});

export const API = axios.create({
  baseURL: ROOT_URL
});

export const axiosAuthInstance = axios.create({
  baseURL: ROOT_URL,
});

export const API2 = axios.create({
  baseURL: ROOT_URL2
});

export const API3 = axios.create({
  baseURL: ROOT_URL3
});

export const axiosAuthInstance2 = axios.create({
  baseURL: ROOT_URL2,
});

export const axiosLoginInstance = axios.create({
  baseURL: ROOT_LOGIN_URL,
});

export const axiosLoginAuthInstance = axios.create({
  baseURL: ROOT_LOGIN_URL,
});

export const axiosNoAuthInstance = axios.create({
  baseURL: ROOT_URL,
});

export const axiosEmptyInstance = axios.create({
  baseURL: '',
});

export const axiosPayAuthInstance = axios.create({
  baseURL: ROOT_URL_PAY,
});


export const BASE_URLS = {
  BOOKING_HUB: '/booking-hub',
  PAYMENT_LINK: '/payment-link',
  INVENTORY_ORDER: '/inventory/order',
  INVENTORY_ORDER_CHARAGE: '/inventory/order-link',
  RECEIPT: '/receipt',
  SUBSCRIPTION_LINK: '/subscription-link',
  INVOICE_LINK: '/invoice-link',
  INVOICE: '/invoice',
  PAYMENT_PAGE_LINK: '/payment-page-link',
  DONATION_PAGE_LINK: '/donation-page-link',
  PAYMENT_BUTTON: '/payment-button',
  SUBSCRIPTION_BUTTON: '/subscription-button',
  SETUP_INTENT: '/setup-session',
  USER_REGISTER: '/auth/addUser',
  AUTHENTICATE: '/auth/authenticate',
  RESPOND_CHALLENGE: '/auth/respondChallenge',
  RESEND_OTP: '/auth/resend-otp',
  USER_PROFILE: 'profile',
  AFFILIATE_ACCOUNT: '/affiliate-account',
  CONNECT_ACCOUNT: '/account/connect',
  FORGOT_PASSWORD: '/auth/forgotPassword',
  RESET_PASSWORD: '/auth/confirmForgotPassword',
  PUBLICKEY_PROFILE: '/account/find-one',
  SETUP_INTENT: '/setup-session/create',
  GET_ACCOUNT: '/account/find-one',
  SETUP_FIND: '/setup-session',
  ECWID_ORDER: 'ecwid-order',
  PAYMENT_WIDGET: '/payment-widget-link',
  ZOHO_PAYMENT_LINK: '/zoho-payment-page',
  WOO_COMMERCE_ORDER: '/woocommerce-order',
  TRANSFER_LINK: '/transfer-links',
  FUNDING_SOURCE: '/funding-source-link',
  CHECKOUT_PAGE: '/checkout-page',
  CASHFREE: '/cashfree-bank',
  GOOGLEPAY_SECRET: '/google-pay-us-credentials/account',
  PAYMENT_SESSION: '/payment-session',
  DEFAULT_LOCATION: 'https://ipapi.co/json/',
  MAP_URL: 'https://maps.googleapis.com/maps/api/geocode/json',
  CAPTCHAURL: '/google-recaptcha?platformType=WEB',
  SPLIT_UP: '/payment-page-meta',
  WOOCOMMERCE_ORDER: '/woocommerce-order',
  SEATS_PAGE: '/seat-page-link',
  SEATS_SPLIT: '/seat-page-meta',
  HEALTH_CHECK: '/health/fd',
  UPLOAD_PAYMENTPAGE_FILE: '/storage/upload/payment-page-document',
  DONATION_SPLIT_UP: '/donation-page-meta',
  SEAT_SPLIT_UP: '/seat-page-meta',
  EVENT_SPLIT_UP: '/event-page/order/split-up/secure',
  MAINTAINACE_API: '/health/maintenance',
  EVENT_PAGE: '/event-page',
  EVENT_PAGE_ORDER: '/event-page/order',
  EVENT_PAGE_ORDER_LINK: '/event-page/order-link',
  ORUM_VERIFICATION: '/orum-verification',
  EXPIRE_HOLD_TOKEN: '/seats/expire-token',
  ROUTING_NUMBER: '/routing-number',
  CONNECT_LIST: '/account/connect/list',
  PARTNER_CONNECT: '/account/connect',
  CONNECT_ACCOUNT_DRAFT: '/account/connect/draft',
  CREATE_PLAID_ACCESS_TOKEN: '/create-secure-link-token',
  INTEGRATION: '/integration',
  PLAID: '/plaid',
  CREATE_VERIFICATION_TOKEN: '/create-verification-link-token',
  UPDATE_MANUAL_VERIFICATION: '/update-manual-verification',
  ENCRIPTION: '/encryption',
  INVOICE_SPLIT_UP: '/invoice-link',
  PAYPAL_CLIENT_TOKEN: '/paypal/get-client-token',
  PAYPAL: 'paypal',
  DIRECTORY_LOOKUP: '/directory/directory-lookup',
  DIRECTORY_VERIFY_OTP: '/directory/verify-otp',
  DIRECTORY_RESEND_OTP: '/directory/resend-otp',
  RETRIVE_DIRECTORY_PAYMENT_METHODS: '/directory/retrieve-directory-methods',
  DIRECTORY_AUTHENTICATE: '/directory/authenticate',
  CONTACT: '/contact',
  ACQUIRER_OFFER: '/acquirer-offer',
};


export const encryptData = ( data, serverPublicKey, clientPrivateKey, keyId) => {
    try {
      const publicKeyBytes = atob(serverPublicKey);
      let keyDataStart = -1;
      for (let i = 0; i < publicKeyBytes.length - 4; i++) {
        if (publicKeyBytes.charCodeAt(i) === 0x03 && 
            publicKeyBytes.charCodeAt(i + 1) === 0x42 && 
            publicKeyBytes.charCodeAt(i + 2) === 0x00 && 
            publicKeyBytes.charCodeAt(i + 3) === 0x04) {
          keyDataStart = i + 4;
          break;
        }
      }
      if (keyDataStart === -1) {
        throw new Error('Could not find public key data in DER format');
      }
      const keyData = publicKeyBytes.slice(keyDataStart, keyDataStart + 64);
      
      if (keyData.length !== 64) {
        throw new Error(`Invalid key data length: ${keyData.length}, expected 64`);
      }
      const publicKeyHex = '04' + Array.from(keyData)
        .map(byte => byte.charCodeAt(0).toString(16).padStart(2, '0'))
        .join('');
      const serverPubKey = ec.keyFromPublic(publicKeyHex, 'hex');
      const sharedSecret = clientPrivateKey.derive(serverPubKey.getPublic());
      const sharedSecretBytes = sharedSecret.toArray();
      const sharedSecretHex = sharedSecretBytes.map(byte => 
        (byte < 0 ? byte + 256 : byte).toString(16).padStart(2, '0')
      ).join('');
      const aesKeyHash = CryptoJS.SHA256(CryptoJS.enc.Hex.parse(sharedSecretHex));
      const aesKey = aesKeyHash.toString(CryptoJS.enc.Hex);
      const iv = CryptoJS.lib.WordArray.random(16);
      const key = CryptoJS.enc.Hex.parse(aesKey);
      const encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      
      return {
        encryptedData: encrypted.toString(),
        keyId: keyId,
        iv: iv.toString(CryptoJS.enc.Base64),
      };
    } catch (error) {
      console.error('Error encrypting data:', error);
      throw new Error('Failed to encrypt data');
    }
  };

export const generateClientKeyPair = () => {
  const keyPair = ec.genKeyPair();
  const publicKey = keyPair.getPublic('hex');
  const privateKey = keyPair;

  return {
    publicKey,
    privateKey,
  };
};

export const DEVICE_BLOCKED_MESSAGE = 'We could not verify this device. Please try again later or contact support.';
export const UNAUTHORIZED_ORIGIN_MESSAGE = 'Unauthorized Origin to Pay';

/**
 * CORS and other browser-blocked requests leave axios with no `response`. Callers already expect
 * a response-shaped rejection (`{ data: { message } }`), so synthesize one instead of rejecting
 * `undefined` — otherwise payment error UIs silently swallow the failure.
 */
const asAxiosRejection = (error) => {
  if (error?.response) return error.response;
  return {
    status: 0,
    corsError: true,
    data: { message: UNAUTHORIZED_ORIGIN_MESSAGE },
  };
};

const buildSecurityHeaders = async (recaptchaToken) => {
  const headers = {};
  if (recaptchaToken) {
    headers['X-Captcha-Token'] = recaptchaToken;
  }
  const device = await getDeviceFingerprint();
  // A half filled pair scores worse than none, so both headers travel together or neither does.
  if (device?.fingerprint && device?.signals) {
    headers['X-Client-Fingerprint'] = device.fingerprint;
    headers['X-Device-Signals'] = device.signals;
  }
  headers['X-Browser-WebDriver'] = String(device?.webdriver === true);
  return headers;
};

/**
 * A device block and a captcha challenge both arrive as HTTP 429, but no captcha will ever clear
 * a block. Re-shaping the rejection with a different status keeps every caller's `status === 429`
 * branch from reopening the captcha modal on a shopper who can only be shown the message.
 */
const asDeviceBlockRejection = (response) => {
  const headers = response?.headers || {};
  const action = headers['x-ratelimit-action'];
  const dimension = headers['x-ratelimit-dimension'];
  if (dimension !== 'DEVICE_FINGERPRINT' || action !== 'RATE_LIMITED') return null;
  return {
    ...response,
    status: 403,
    deviceBlocked: true,
    rateLimitAction: action,
    rateLimitDimension: dimension,
    retryAfterSeconds: Number(headers['retry-after']) || null,
    data: { ...(response?.data || {}), message: DEVICE_BLOCKED_MESSAGE },
  };
};

export const getServerEncription = async (recaptchaToken = null) => {
  const config = { headers: await buildSecurityHeaders(recaptchaToken) };
  try {
    const { data: { entity } } = await API.post(BASE_URLS.ENCRIPTION, {}, config);
    return entity;
  } catch (response) {
    if (response?.status === 429) {
      throw asDeviceBlockRejection(response) || response;
    }
    throw response;
  }
};

export const getPayPalClientToken = async (id) => {
  const { data: { message } } = await API.get(`${BASE_URLS.PAYPAL}/${id}/config`);
  return message;
};

export const getMrn = async (psGid, psSecret) => {
  const url = `${BASE_URLS.PAYMENT_SESSION}/${psGid}/mrn`;
  const { data: { message } } = await API2.get(url, {
    headers: {
      'ps-client-secret': psSecret,
    },
  });
  return message;
};

export const action = async (psGid, psSecret) => {
  const url = `${BASE_URLS.PAYMENT_SESSION}/${psGid}/action`;
  const response = await API2.post(url, {}, {
    headers: {
      'ps-client-secret': psSecret,
    },
  });
  return response;
};

export const cashfreeAction = async (psGid, psSecret) => {
  const url = `${BASE_URLS.PAYMENT_SESSION}/${psGid}/recon`;
  const response = await API3.get(url, {
    headers: {
      'ps-client-secret': psSecret,
    },
  });
  return response;
}

export const getListConnect = async () => {
  const { data : { entity } } = await axiosAuthInstance(BASE_URLS.CONNECT_LIST);
  return entity;
};

export const getBankRtp = async (routing) => {
  const { data : { entity } } = await API.get(`${BASE_URLS.ROUTING_NUMBER}/${routing}`);
  return entity;
};

export const bankVerification = async (config) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.ORUM_VERIFICATION}/secure`, config);
  return entity;
};

export const orunVerification = async (id, code) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.ORUM_VERIFICATION}/${id}/verify?code=${code}`, {});
  return entity;
};

export const getHealthCheck = async () => {
  const { data : { entity } } = await HEALTHAPI.get(BASE_URLS.HEALTH_CHECK);
  return entity;
};

export const getSessionAuth = async (config, id) => {
  const { data : { entity } } = await API.get(`${BASE_URLS.SETUP_FIND}/${id}`, config);
  return entity;
};

export const getAccountInfo = async (config) => {
  const { data : { entity } } = await API.get(BASE_URLS.GET_ACCOUNT, config);
  return entity;
};

export const addIntent = async (params, config) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.SETUP_INTENT}`, params, config);
  return entity;
};

export const getEventDetailsById = async (id, params) => {
  const url = params?`${BASE_URLS.SEATS_PAGE}/${id}${params}`:`${BASE_URLS.SEATS_PAGE}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const getEventPaymentDetails = async (params, id) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.SEATS_SPLIT}/${id}/split-up`, params);
  return entity;
};

export const eventChargeById = async (id, paymentMethodId) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': paymentMethodId?.publicKey,
    'x-enc-key-id': paymentMethodId?.keyId,
    'x-enc-iv': paymentMethodId?.iv,
  };
  const { data: { entity } } = await API.post(`${BASE_URLS.SEATS_PAGE}/${id}/charge`, { data: paymentMethodId?.data }, config);
  return entity;
};

export const getEventPageDetailsById = async (id, params) => {
  const url = params?`${BASE_URLS.EVENT_PAGE}/${id}/secure${params}`:`${BASE_URLS.EVENT_PAGE}/${id}/secure`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const expireHoldToken = async (id) => {
  const url = `${BASE_URLS.EXPIRE_HOLD_TOKEN}/${id}`;
  const { data : { entity } } = await API.post(url);
  return entity;
};

export const eventsPageSplitUpApi = async (payload) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.EVENT_PAGE_ORDER}/split-up/secure`, payload);
  return entity;
};

export const createEventPageOrder = async (payload) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.EVENT_PAGE_ORDER}/secure`, payload);
  return entity;
};

export const getEventPageOrderDetailsById = async (id, params) => {
  const url = params?`${BASE_URLS.EVENT_PAGE_ORDER_LINK}/${id}${params}`:`${BASE_URLS.EVENT_PAGE_ORDER_LINK}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const addEventPageOrderChargeById = async (id, chargeData) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': chargeData?.publicKey,
    'x-enc-key-id': chargeData?.keyId,
    'x-enc-iv': chargeData?.iv,
  };
  const { data: { entity } } = await API.post(`${BASE_URLS.EVENT_PAGE_ORDER_LINK}/${id}/charge`, { data: chargeData?.data }, config);
  return entity;
};

export const getPaymentLinkById = async (id, params) => {
  const url = params?`${BASE_URLS.PAYMENT_LINK}/${id}${params}`:`${BASE_URLS.PAYMENT_LINK}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const getInventoryOrderById = async (id, params) => {
  const url = params?`${BASE_URLS.INVENTORY_ORDER_CHARAGE}/${id}${params}`:`${BASE_URLS.INVENTORY_ORDER_CHARAGE}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const addInventoryOrderChargeById = async (id, chargeData) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': chargeData?.publicKey,
    'x-enc-key-id': chargeData?.keyId,
    'x-enc-iv': chargeData?.iv,
  };
  const { data : { entity } } = await API.post(`${BASE_URLS.INVENTORY_ORDER_CHARAGE}/${id}/charge`, { data: chargeData?.data }, config);
  return entity;
};

export const getWoocommerceById = async (id, params) => {
  const url = params?`${BASE_URLS.WOOCOMMERCE_ORDER}/${id}${params}`:`${BASE_URLS.WOOCOMMERCE_ORDER}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const getZohoPaymentLinkById = async (id, params) => {
  const url = params?`${BASE_URLS.ZOHO_PAYMENT_LINK}/${id}${params}`:`${BASE_URLS.ZOHO_PAYMENT_LINK}/${id}`;
  const { data : { entity } } = await PAYAPI.get(url);
  return entity;
};

export const addChargeById = async (id, paymentMethod) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': paymentMethod?.publicKey,
    'x-enc-key-id': paymentMethod?.keyId,
    'x-enc-iv': paymentMethod?.iv,
  };
  const { data : { entity } } = await API.post(`${BASE_URLS.PAYMENT_LINK}/${id}/charge`, {data: paymentMethod?.data}, config);
  return entity;
};

export const orderChargeById = async (id, paymentMethodId) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.WOOCOMMERCE_ORDER}/${id}/charge`, paymentMethodId);
  return entity;
};

export const getZohoPaymentLinkByAuth = async (id, params) => {
  const { data : { entity } } = await PAYAPI.post(`${BASE_URLS.ZOHO_PAYMENT_LINK}/${id}/pay/action/${params}`);
  return entity;
};

export const downloadReceiptByReceiptNumber = async (receiptNumber) => {
  const { data : { entity } } = await API.get(`${BASE_URLS.RECEIPT}/${receiptNumber}/download`);
  return entity;
};

export const pauseSubscriptionLink = async (interval, id) => {
  const { data : { entity } } = await API2.patch(`${BASE_URLS.SUBSCRIPTION_LINK}/${id}/pause`, {pauseInterval: interval});
  return entity;
};

export const paymentMethodDelete = async (paymentId, id) => {
  const { data : { entity } } = await API2.delete(`${BASE_URLS.SUBSCRIPTION_LINK}/${id}/delete-payment-method/${paymentId}`);
  return entity;
};

export const planUpdate = async (planId, id) => {
  const { data : { entity } } = await API2.patch(`${BASE_URLS.SUBSCRIPTION_LINK}/${id}/switch-plan/${planId}`);
  return entity;
};

export const paymentUpdate = async (paymentId, id) => {
  const { data : { entity } } = await API2.patch(`${BASE_URLS.SUBSCRIPTION_LINK}/${id}/update-default-payment-method/${paymentId}`);
  return entity;
};

export const cancelSubscriptionLink = async (id) => {
  const { data : { entity } } = await API2.patch(`${BASE_URLS.SUBSCRIPTION_LINK}/${id}/cancel`, {});
  return entity;
};

export const resumeSubscriptionLink = async (id) => {
  const { data : { entity } } = await API2.patch(`${BASE_URLS.SUBSCRIPTION_LINK}/${id}/resume`, {});
  return entity;
};

export const findSubscriptionLinkById = async (id, params) => {
  const url = params?`${BASE_URLS.SUBSCRIPTION_LINK}/${id}${params}`:`${BASE_URLS.SUBSCRIPTION_LINK}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const findSubscriptionBillingHistoryById = async (gid) => {
  const { data : { entity } } = await API.get(`${BASE_URLS.SUBSCRIPTION_LINK}/${gid}/history?sortBy=paymentDate&direction=DESC`);
  return entity;
};

export const updateSubscriptionLink = async (gid, data) => {
  const { data : { entity } } = await API.patch(`${BASE_URLS.SUBSCRIPTION_LINK}/${gid}`, data);
  return entity;
};

export const addSubscriptionLinkPaymentMethod = async (gid, paymentMethod) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.SUBSCRIPTION_LINK}/${gid}/payment-method`, paymentMethod);
  return entity;
};

export const getInvoiceLinkById = async (id, params) => {
  const url = params?`${BASE_URLS.INVOICE_LINK}/${id}${params}`:`${BASE_URLS.INVOICE_LINK}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const downloadInvoiceByInvoicePdfKey = async (invoicePdfKey) => {
  const { data : { entity } } = await API.get(`${BASE_URLS.INVOICE}/${invoicePdfKey}/download`);
  return entity;
};

export const payInvoiceById = async (id, paymentMethod) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': paymentMethod?.publicKey,
    'x-enc-key-id': paymentMethod?.keyId,
    'x-enc-iv': paymentMethod?.iv,
  };
  const { data : { entity } } = await API.patch(`${BASE_URLS.INVOICE_LINK}/${id}/pay`, { data: paymentMethod?.data }, config);
  return entity;
};

export const findPaymentPageLinkById = async (id, params) => {
  const url = params ? `${BASE_URLS.PAYMENT_PAGE_LINK}/${id}${params}` : `${BASE_URLS.PAYMENT_PAGE_LINK}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const findDonationPageLinkById = async (id, params) => {
  const url = params ? `${BASE_URLS.DONATION_PAGE_LINK}/${id}${params}` : `${BASE_URLS.DONATION_PAGE_LINK}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const findPaymentPageById = async (id, params) => {
  const url = params?`${BASE_URLS.PAYMENT_PAGE_LINK}/${id}${params}`:`${BASE_URLS.PAYMENT_PAGE_LINK}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const paymentPageChargeById = async (id, paymentMethod) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': paymentMethod?.publicKey,
    'x-enc-key-id': paymentMethod?.keyId,
    'x-enc-iv': paymentMethod?.iv,
  };
  const { data: { entity } } = await API.post(`${BASE_URLS.PAYMENT_PAGE_LINK}/${id}/charge`, { data: paymentMethod?.data }, config);
  return entity;
};

export const donationPageChargeById = async (id, paymentMethod) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': paymentMethod?.publicKey,
    'x-enc-key-id': paymentMethod?.keyId,
    'x-enc-iv': paymentMethod?.iv,
  };
  const { data: { entity } } = await API.post(`${BASE_URLS.DONATION_PAGE_LINK}/${id}/charge`, { data: paymentMethod?.data }, config);
  return entity;
};

export const invoiceLinkSplitUp = async (id, invoiceData) => {
  const { data: { entity }} = await API.post(`${BASE_URLS.INVOICE_SPLIT_UP}/${id}/split-up`, invoiceData);
  return entity;
};

export const paymentPageSplitUp = async (id, paymentMethod) => {
  const { data: { entity }} = await API.post(`${BASE_URLS.SPLIT_UP}/${id}/split-up`, paymentMethod);
  return entity;
};

export const donationPageSplitUp = async (id, paymentMethod) => {
  const { data: { entity }} = await API.post(`${BASE_URLS.DONATION_SPLIT_UP}/${id}/split-up`, paymentMethod);
  return entity;
};

export const seatPageSplitUp = async (id, paymentMethod) => {
  const { data: { entity }} = await API.post(`${BASE_URLS.SEAT_SPLIT_UP}/${id}/split-up`, paymentMethod);
  return entity;
};

export const eventPageSplitUp = async (paymentMethod) => {
  const { data: { entity }} = await API.post(`${BASE_URLS.EVENT_SPLIT_UP}`, paymentMethod);
  return entity;
};

export const paymentLinkIavToken = async (id, customer) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.PAYMENT_LINK}/${id}/iav-token`, customer);
  return entity;
};

export const getPaymentButtonById = async (id, params) => {
  const url = params?`${BASE_URLS.PAYMENT_BUTTON}/${id}${params}`:`${BASE_URLS.PAYMENT_BUTTON}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const addPaymentButtonChargeById = async (id, paymentDetails) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': paymentDetails?.publicKey,
    'x-enc-key-id': paymentDetails?.keyId,
    'x-enc-iv': paymentDetails?.iv,
  };

  const { data: { entity } } = await API.post(`${BASE_URLS.PAYMENT_BUTTON}/${id}/charge`, { data: paymentDetails?.data }, config);
  return entity;
};

export const getWalletOrderInfo = async (id, psClientSecret) => {
  const url = `${BASE_URLS.PAYMENT_SESSION}/${id}/paypal-order`;
  const { data : { entity } } = await API2.get(url, {
    headers: {
      'ps-client-secret': psClientSecret,
    },
  });
  return entity;
};

export const confirmWalletOrderInfo = async (id, psClientSecret) => {
  const url = `${BASE_URLS.PAYMENT_SESSION}/${id}/action`;
  const { data : { entity } } = await API2.post(url, {}, {
    headers: {
      'ps-client-secret': psClientSecret,
    },
  });
  return entity;
};

export const getSubscriptionButtonById = async (id, params) => {
  const url = params?`${BASE_URLS.SUBSCRIPTION_BUTTON}/${id}${params}`:`${BASE_URLS.SUBSCRIPTION_BUTTON}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const addSubscriptionButtonChargeById = async (id, paymentDetails) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.SUBSCRIPTION_BUTTON}/${id}/charge`, paymentDetails);
  return entity;
};

export const getEcwidOrderByGid = async (gid, params) => {
  const url = params?`${BASE_URLS.ECWID_ORDER}/${gid}${params}`:`${BASE_URLS.ECWID_ORDER}/${gid}`;
  const { data : { entity } } = await axiosPayAuthInstance.get(url);
  return entity;
};

export const ecwidOrderChargeByGid = async (id, paymentDetails) => {
  const {data: {entity}} = await axiosPayAuthInstance.post(`${BASE_URLS.ECWID_ORDER}/${id}/charge`, paymentDetails);
  return entity;
};

export const addPaymentWidgetChargeById = async (id, paymentDetails) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': paymentDetails?.publicKey,
    'x-enc-key-id': paymentDetails?.keyId,
    'x-enc-iv': paymentDetails?.iv,
  };
  const response = await API.post(`${BASE_URLS.PAYMENT_WIDGET}/${id}/charge`, { data: paymentDetails?.data }, config);
  return response;
};

export const getPaymentWidgetById = async (id, params) => {
  const url = params?`${BASE_URLS.PAYMENT_WIDGET}/${id}${params}`:`${BASE_URLS.PAYMENT_WIDGET}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const addZohoPaymentChargeById = async (id, zohoPaymentDetails) => {
  const { data : { entity } } = await PAYAPI.post(`${BASE_URLS.ZOHO_PAYMENT_LINK}/${id}/pay`, zohoPaymentDetails);
  return entity;
};

export const declinePaymentLinkByGid = async (gid) => {
  const { data : { entity } } = await API.delete(`${BASE_URLS.PAYMENT_LINK}/${gid}/decline`);
  return entity;
};

export const declineWoocommerceOrderByGid = async (gid) => {
  const { data : { entity } } = await API.patch(`${BASE_URLS.WOOCOMMERCE_ORDER}/${gid}/cancel`);
  return entity;
};

export const getPlaidCreateLinkToken = async ({ gid, enableManualAuth }) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.FUNDING_SOURCE}/${gid}/plaid/create-link-token`, {
    enableManualAuth,
  });
  return entity;
};

export const cancelEcwidOrderByGid = async (gid) => {
  const { data : { entity } } = await axiosPayAuthInstance.delete(`${BASE_URLS.ECWID_ORDER}/${gid}/cancel`);
  return entity;
};

export const cancelZohoPaymentLink = async (gid) => {
  const { data : { entity } } = await PAYAPI.patch(`${BASE_URLS.ZOHO_PAYMENT_LINK}/${gid}/cancel`);
  return entity;
};

export const geWooCommerceOrderByGid = async (gid, params) => {
  const url = params?`${BASE_URLS.WOO_COMMERCE_ORDER}/${gid}${params}`:`${BASE_URLS.WOO_COMMERCE_ORDER}/${gid}`;
  const { data : { entity } } = await axiosPayAuthInstance.get(url);
  return entity;
};

export const wooCommerceOrderChargeByGid = async (id, paymentDetails) => {
  const {data: {entity}} = await axiosPayAuthInstance.post(`${BASE_URLS.WOO_COMMERCE_ORDER}/${id}/charge`, paymentDetails);
  return entity;
};

export const cancelWooCommerceOrderByGid = async (gid) => {
  const { data : { entity } } = await axiosPayAuthInstance.delete(`${BASE_URLS.WOO_COMMERCE_ORDER}/${gid}/cancel`);
  return entity;
};

export const getFundingSourceById = async (id) => {
  const url = `${BASE_URLS.FUNDING_SOURCE}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const getTransferLinkById = async (id, params) => {
  const url = params?`${BASE_URLS.TRANSFER_LINK}/${id}${params}`:`${BASE_URLS.TRANSFER_LINK}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const declineTransferLinkByGid = async (gid) => {
  const { data : { entity } } = await API.delete(`${BASE_URLS.TRANSFER_LINK}/${gid}/decline`);
  return entity;
};

export const addTransferById = async (id, transferData) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.TRANSFER_LINK}/${id}/charge`, transferData);
  return entity;
};

export const addFundingSourceLink = async (id, data) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.FUNDING_SOURCE}/${id}/funding-source`, data);
  return entity;
};

export const patchContact = async (id, data) => {
  const { data : { entity } } = await API.patch(`${BASE_URLS.CONTACT}/${id}`, data);
  return entity;
};

export const patchContactAddress = async (id, data) => {
  const response = await API.patch(`${BASE_URLS.CONTACT}/address/${id}`, data);
  return response;
};

export const addFundingSourceId = async (id, transferData) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.TRANSFER_LINK}/${id}/funding-source`, transferData);
  return entity;
};

export const getCheckoutPageById = async (id, params) => {
  const url = params?`${BASE_URLS.CHECKOUT_PAGE}/${id}${params}`:`${BASE_URLS.CHECKOUT_PAGE}/${id}`;
  const { data : { entity } } = await API.get(url, {
    headers: {
      'X-secure': '164',
    },
  });
  return entity;
};

export const getCheckoutReconnection = async (paymentSession, psClientSecret) => {
  const url = `${BASE_URLS.PAYMENT_SESSION}/${paymentSession}/recon`;
  const { data : { entity } } = await API2.get(url, {
    headers: {
      'ps-client-secret': psClientSecret,
    },
  });
  return entity;
};

export const getQrPaymentReconnection = async (paymentSession, psClientSecret) => {
  const url = `${BASE_URLS.PAYMENT_SESSION}/${paymentSession}`;
  const { data : { entity } } = await API.get(url, {
    headers: {
      'ps-client-secret': psClientSecret,
    },
  });
  return entity;
};

export const addCheckoutPageChargeById = async (id, chargeData) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.CHECKOUT_PAGE}/${id}/charge`, chargeData);
  return entity;
};

export const confirmZellPayment = async (id, chargeData) => {
  const url = `${BASE_URLS.PAYMENT_SESSION}/${id}/action`;
  const { data: { entity } } = await API2.post(url, chargeData);
  return entity;
};

export const addPaymentLinkPageChargeById = async (id, chargeData) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': chargeData?.publicKey,
    'x-enc-key-id': chargeData?.keyId,
    'x-enc-iv': chargeData?.iv,
  };
  const { data : { entity } } = await API.post(`${BASE_URLS.PAYMENT_LINK}/${id}/charge`, {data: chargeData?.data}, config);
  return entity;
};
export const addPaymentButtonPageChargeById = async (id, chargeData) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': chargeData?.publicKey,
    'x-enc-key-id': chargeData?.keyId,
    'x-enc-iv': chargeData?.iv,
  };
  const { data : { entity } } = await API.post(`${BASE_URLS.PAYMENT_BUTTON}/${id}/charge`, {data: chargeData?.data}, config);
  return entity;
};

export const addUpiPaymentsChargeById = async (upiUrl, chargeData) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': chargeData?.publicKey,
    'x-enc-key-id': chargeData?.keyId,
    'x-enc-iv': chargeData?.iv,
  };
  const { data: { entity }} = await API.post(`${upiUrl}/charge`, { data: chargeData?.data }, config);
  return entity;
};

export const getCheckoutCardCharges = async (id, card) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.CHECKOUT_PAGE}/${id}/fee`, {cardNumber: card});
  return entity;
}
export const getCheckoutChallanCharges = async (id) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.CHECKOUT_PAGE}/${id}/fee`, {});
  return entity;
}
export const getPaymentLinkCardCharges = async (id, card) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.PAYMENT_LINK}/${id}/fee`, {cardNumber: card});
  return entity;
}
export const getPaymentLinkChallanCharges = async (id) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.PAYMENT_LINK}/${id}/fee`, {});
  return entity;
}
export const getPaymentButtonCardCharges = async (id, card) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.PAYMENT_BUTTON}/${id}/fee`, {cardNumber: card});
  return entity;
}
export const getPaymentButtonChallanCharges = async (id) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.PAYMENT_BUTTON}/${id}/fee`, {});
  return entity;
}

export const getLocationDetails = async () => {
  const { data } = await axios.get(BASE_URLS.DEFAULT_LOCATION);
  return data;
}

export const getLocationByZipCode = async (zip) => {
  const { data: { results } } = await axios.get(`${BASE_URLS.MAP_URL}?address=${zip}&sensor=true&key=${GOOGLE_APIKEY}`);
  return results;
}

export const getSecretValuesById = async (id) => {
  const url = `${BASE_URLS.GOOGLEPAY_SECRET}/${id}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const getRecaptchToken = async () => {
  const { data : { entity } } = await API.get(BASE_URLS.CAPTCHAURL);
  return entity;
};

export const getStripeRedirectUrl = async (path) => {
  let url;
  if(path.includes('/refresh') || path.includes('/complete')) {
    url = path;
  } else {
    url = `${path}/initiate`;
  }
  const { data } = await API.get(url);
  return data;
}

export const paymentWidgetSplitUp = async (id, payaload) => {
  const { data: { entity }} = await API.get(`${BASE_URLS.PAYMENT_WIDGET}/${id}/split-up?amount=${payaload}`);
  return entity;
};

export const paymentLinkSplitUp = async (id) => {
  const { data: { entity }} = await API.get(`${BASE_URLS.PAYMENT_LINK}/${id}/split-up`);
  return entity;
};

export const calculatePaymentLinkSplitUp = async (id, payload) => {
  const { data: { entity }} = await API.post(`${BASE_URLS.PAYMENT_LINK}/${id}/split-up`, payload);
  return entity;
};

export const findSubscriptionV2LinkById = async (id, params) => {
  const url = params?`${BASE_URLS.SUBSCRIPTION_LINK}/${id}${params}`:`${BASE_URLS.SUBSCRIPTION_LINK}/${id}`;
  const { data : { entity } } = await API2.get(url);
  return entity;
};

export const updateSubscriptionV2Link = async (gid, data) => {
  const { data : { entity } } = await API2.patch(`${BASE_URLS.SUBSCRIPTION_LINK}/${gid}`, data);
  return entity;
};

export const findSubscriptionV2BillingHistoryById = async (gid) => {
  const { data : { entity } } = await API2.get(`${BASE_URLS.SUBSCRIPTION_LINK}/${gid}/history`);
  return entity;
};

export const addSubscriptionV2LinkPaymentMethod = async (gid, paymentMethod) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': paymentMethod?.publicKey,
    'x-enc-key-id': paymentMethod?.keyId,
    'x-enc-iv': paymentMethod?.iv,
  };
  const { data: { entity } } = await API2.post(`${BASE_URLS.SUBSCRIPTION_LINK}/${gid}/payment-method`, { data: paymentMethod?.data }, config);
  return entity;
};

export const manualSubscritpionV2LinkPaymentMethod = async (gid, paymentMethod) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': paymentMethod?.publicKey,
    'x-enc-key-id': paymentMethod?.keyId,
    'x-enc-iv': paymentMethod?.iv,
  };
  const { data: { entity } } = await API2.post(`${BASE_URLS.SUBSCRIPTION_LINK}/${gid}/manual-invoice-payment`, { data: paymentMethod?.data }, config);
  return entity;
};

export const getSubscriptionLinkManualInvoice = async (gid) => {
  const { data: { entity } } = await API2.get(`${BASE_URLS.SUBSCRIPTION_LINK}/${gid}/manual-invoice`);
  return entity;
};

export const getSubscriptionButtonByIdV2 = async (id, params) => {
  const url = params?`${BASE_URLS.SUBSCRIPTION_BUTTON}/${id}${params}`:`${BASE_URLS.SUBSCRIPTION_BUTTON}/${id}`;
  const { data : { entity } } = await API2.get(url);
  return entity;
};

export const addSubscriptionButtonV2ChargeById = async (id, paymentDetails) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': paymentDetails?.publicKey,
    'x-enc-key-id': paymentDetails?.keyId,
    'x-enc-iv': paymentDetails?.iv,
  };
  const { data : { entity } } = await API2.post(`${BASE_URLS.SUBSCRIPTION_BUTTON}/${id}/charge`, { data: paymentDetails?.data }, config);
  return entity;
};

export const getPreSignedUrl = async (id, params) => {
  const url = `${BASE_URLS.UPLOAD_PAYMENTPAGE_FILE}`;
  const { data : { entity } } = await API.get(url);
  return entity;
};

export const uploadFile = async (fileUrl,keyType) => {
  const urls = `${BASE_URLS.UPLOAD_PAYMENTPAGE_FILE}`;
  const { data : { entity } } = await API.post(urls , {fileUrl,keyType});

  return entity;
};

export const addOrumVerification = async (params, id) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.ORUM_VERIFICATION}/${id}/verify?code=${params?.code}`);
  return entity;
};

export const getOrumVerificationStatus = async (id) => {
  const { data : { entity } } = await API.get(`${BASE_URLS.ORUM_VERIFICATION}/${id}/verify`);
  return entity;
}

export const getPlaidToken = async ({ id, isTest, enableManualAuth }) => {
  const { data : { entity } } = await API.post(`integration/plaid/${id}${BASE_URLS.CREATE_PLAID_ACCESS_TOKEN}?isTest=${isTest}`, {
    enableManualAuth
  });
    return entity;
}

export const getVerificationLinkToken = async (referenceGid) => {
  const { data : { entity } } = await API.post(`${BASE_URLS.INTEGRATION}${BASE_URLS.PLAID}/${referenceGid}${BASE_URLS.CREATE_VERIFICATION_TOKEN}`, {});
  return entity;
}

export const updateManualVerification = async (referenceGid) => {
  const { data : { entity } } = await API.patch(`${BASE_URLS.INTEGRATION}${BASE_URLS.PLAID}/${referenceGid}${BASE_URLS.UPDATE_MANUAL_VERIFICATION}`, {});
  return entity;
}

const updateTestPaymentTypes = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;

  if (obj.entity?.account?.portal?.test === true && obj.entity.account.defaultTestPaymentTypes) {
    obj.entity.account.supportedPaymentTypes = obj.entity.account.defaultTestPaymentTypes;
  }

  return obj;
};

API.interceptors.response.use(value => {
  if (value && value.data) {
    updateTestPaymentTypes(value.data);
  }
  return value;
}, error => Promise.reject(asAxiosRejection(error)));

API2.interceptors.response.use(value => {
  if (value && value.data) {
    updateTestPaymentTypes(value.data);
  }
  return value;
}, error => Promise.reject(asAxiosRejection(error)));

axiosLoginInstance.interceptors.response.use(value => {
  return value;
}, error => Promise.reject(asAxiosRejection(error)));

axiosPayAuthInstance.interceptors.response.use(value => {
  if (value && value.data) {
    updateTestPaymentTypes(value.data);
  }
  return value;
}, error => Promise.reject(asAxiosRejection(error)));

PAYAPI.interceptors.response.use(value => {
  if (value && value.data) {
    updateTestPaymentTypes(value.data);
  }
  return value;
}, error => Promise.reject(asAxiosRejection(error)));

axiosAuthInstance.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem(TOKENS.ACCESS_TOKEN)}`;
  return config;
}, (err) => {
  return Promise.reject(err);
});

export const getBookingHubById = async (id) => {
  const { data: { entity } } = await API.get(`${BASE_URLS.BOOKING_HUB}/${id}/secure?expand=tags`);
  return entity;
};

export const getBookingHubLocationsById = async (id) => {
  const { data: { entity } } = await API.get(`${BASE_URLS.BOOKING_HUB}/location/${id}/secure?expand=currency,tags,address.country&page=1&size=80`);
  return entity;
};
// API 1: Called on page load — returns location + all available time slots grouped by date
export const getBookingHubTimeSlots = async (locationGid) => {
  const { data: { entity } } = await API.get(
    `${BASE_URLS.BOOKING_HUB}/location/${locationGid}/time-slots?expand=currency,tags,address.country,supports`
  );
  return entity;
};

// API 2: Called when user clicks a time slot — returns slot details with products/items
export const getBookingHubSlotDetails = async (scheduleGid) => {
  const { data: { entity } } = await API.get(
    `${BASE_URLS.BOOKING_HUB}/location/${scheduleGid}/slot-details?expand=timeSlots.events.eventId,timeSlots.products.productId,timeSlots.products.items.itemId,timeSlots.products.items`
  );
  return entity;
};

// Keep legacy functions for backward compatibility
export const getBookingHubSlots = async (gid, locationGid, date) => {
  try {
    const entity = await getBookingHubTimeSlots(locationGid);
    // Filter timeSlots for the requested date
    const dateEntry = (entity.timeSlots || []).find(ts => ts.date === date);
    return {
      slots: dateEntry ? dateEntry.timeSlots : [],
      scheduleGid: dateEntry ? dateEntry.gid : null,
    };
  } catch (e) {
    return { slots: [], scheduleGid: null };
  }
};

export const getBookingHubTicketTypes = async (gid, locationGid, slotHashOrScheduleGid) => {
  const entity = await getBookingHubSlotDetails(slotHashOrScheduleGid);
  const items = [];
  for (const ts of (entity.timeSlots || [])) {
    for (const product of (ts.products || [])) {
      for (const item of (product.items || [])) {
        if (item.isAvailable !== false) {
          items.push({
            gid: item.gid,
            name: item.name,
            amount: item.amount,
            stockEnabled: item.stockEnabled,
            currentStock: item.currentStock,
            isAvailable: item.isAvailable,
          });
        }
      }
    }
  }
  return { ticketTypes: items };
};

export const bookingHubSplitUp = async (payload) => {
  const { data: { entity } } = await API.post(`${BASE_URLS.BOOKING_HUB}/secure/order/split-up`, payload);
  return entity;
};

export const createBookingHubOrder = async (payload) => {
  const { data: { entity } } = await API.post(`${BASE_URLS.BOOKING_HUB}/secure/order`, payload);
  return entity;
};

export const getBookingHubOrderLinkDetails = async (id) => {
  const { data: { entity } } = await API.get(`${BASE_URLS.BOOKING_HUB}/order-link/${id}`);
  return entity;
};

export const addBookingHubOrderChargeById = async (id, chargeData) => {
  const config = {};
  config.headers = {
    'x-enc-public-key': chargeData?.publicKey,
    'x-enc-key-id': chargeData?.keyId,
    'x-enc-iv': chargeData?.iv,
  };
  const { data: { entity } } = await API.post(`${BASE_URLS.BOOKING_HUB}/order-link/${id}/charge`, { data: chargeData?.data }, config);
  return entity;
};
